import React, { useEffect, useRef, useState } from 'react';
import Close from '../../_styles/images/close-icon-green.svg';


export default function CardReplacementConfirmPopup(props) {
  const node = useRef();

  function updateCloseKeydown(e) {
    if (e.which === 13) {
      props.close()
    }
  }
  function updateStaykeydown(e) {
    if (e.which === 13) {
      props.close()
    }
  }

  return (
    <div className="charges-popup show" id='leave-vanpool-popup' aria-live='polite' role='alert' aria-modal='true' ref={node}>
      <div className='leave-container'>
      <div className="leave-vanpool-container">
        <div className='top-header'>
          <button
            role='button'
            className="close traditional"
            onClick={() => props.close()}
            onKeyDown={updateCloseKeydown}
            tabIndex={0}
            aria-label="Close edit driving schedule popup"
          >
            <img src={Close} alt='Close' />
          </button>
        </div>
        <div className="sp-header">
          <div className='header'>
            <div className='heading'>
            Confirm Card Replacement
            </div>
          </div>
        </div>
        <div className='leave-vanpool-popup-container'>
          <div className='content'>
          Your original saved card will be removed and replaced with this card.
          </div>
        </div>
        <div className='button-container'>
          <button tabIndex={0} className='leave-button' onClick={() => props.close()} onKeyDown={updateStaykeydown}>Cancel</button>
          <button tabIndex={0} className='continue-button' onClick={() => props.onContinue()} onKeyDown={updateCloseKeydown}>Continue</button>
        </div>
      </div>

      </div>
    </div>
  );
}
